const machineFilterButtonSelector = '[data-machine-filter]';

function applyMachineFilter(filterRoot, category, shouldScroll = false) {
  const productList = document.querySelector('#collection product-list');
  if (!productList) return;

  const cards = Array.from(productList.querySelectorAll('[data-machine-filter-category]'));
  let visibleCount = 0;

  cards.forEach((card) => {
    const visible = category === 'all' || card.dataset.machineFilterCategory === category;
    card.hidden = !visible;
    if (visible) visibleCount += 1;
  });

  productList.querySelectorAll('.product-list__promo').forEach((promo) => {
    promo.hidden = category !== 'all';
  });

  filterRoot.querySelectorAll(machineFilterButtonSelector).forEach((button) => {
    const selected = button.dataset.machineFilter === category;
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
  });

  filterRoot.dataset.activeMachineFilter = category;

  const status = filterRoot.querySelector('[data-machine-filter-status]');
  const statusText = category === 'all' ? '' : `${visibleCount} produkter vises`;
  if (status && status.textContent !== statusText) status.textContent = statusText;

  if (shouldScroll) {
    document.getElementById('collection')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest(machineFilterButtonSelector);
  if (!button) return;

  const filterRoot = button.closest('[data-machine-collection-filters]');
  if (!filterRoot) return;

  event.preventDefault();
  applyMachineFilter(filterRoot, button.dataset.machineFilter, true);
});

new MutationObserver((mutations) => {
  const productListWasReplaced = mutations.some((mutation) => {
    return Array.from(mutation.addedNodes).some((node) => {
      return node.nodeType === Node.ELEMENT_NODE
        && (node.matches?.('#collection product-list') || node.querySelector?.('#collection product-list'));
    });
  });

  if (!productListWasReplaced) return;

  window.requestAnimationFrame(() => {
    document.querySelectorAll('[data-machine-collection-filters]').forEach((filterRoot) => {
      applyMachineFilter(filterRoot, filterRoot.dataset.activeMachineFilter || 'all');
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });
